// extracted by mini-css-extract-plugin
export var actionButton = "_6x-1";
export var actionButtons = "_6x-2";
export var actions = "_6x-0";
export var aiUnread = "_6x-10";
export var alignCenter = "_6x-h";
export var backWrapper = "_6x-3";
export var cellContainer = "_6x-4";
export var checkboxContainer = "_6x-5";
export var contentContainer = "_6x-6";
export var contentHeader = "_6x-8";
export var conversationsTableWrapper = "_6x-s";
export var draftReplyBadgeContainer = "_6x-m";
export var dropdownItem = "_6x-b";
export var dropdownItemsContainer = "_6x-a";
export var dropdownTitle = "_6x-c";
export var errorIcon = "_6x-7";
export var filter = "_6x-d";
export var gray = "_6x-i";
export var headerActionButtons = "_6x-e";
export var headerCheckboxContainer = "_6x-f";
export var icon = "_6x-j";
export var menuContainer = "_6x-k";
export var noMoreTicketsIcon = "_6x-12";
export var noMoreTicketsSubText = "_6x-13";
export var oneLine = "_6x-l";
export var optionsButton = "_6x-n";
export var plus = "_6x-o";
export var portalButtonsWrapper = "_6x-g";
export var red = "_6x-p";
export var scrolledTop = "_6x-9";
export var search = "_6x-q";
export var selectedConversationsCount = "_6x-r";
export var spinner = "_6x-t";
export var strong = "_6x-u";
export var summaryCell = "_6x-v";
export var tableContainer = "_6x-11";
export var tagContainer = "_6x-w";
export var threeDots = "_6x-x";
export var twoLines = "_6x-y";
export var unread = "_6x-z";